export default __webpack_public_path__ + "static/media/leaves.d83544b5.jpeg";